import React from 'react';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import type { ProductsSequence } from 'common/contracts';

import Button from 'components/Button/Button';

import type { IProgressBarTabProps } from '../../ProgressBars.types';
import MilestoneCard from '../Sections/MilestoneCard';

interface IConfigurationTabProps
  extends Pick<IProgressBarTabProps, 'formikProps'> {
  isMilestoneDesign: boolean;
}

const ConfigurationTab: React.FC<IConfigurationTabProps> = ({
  formikProps,
  isMilestoneDesign
}) => {
  const { values, setFieldValue } = formikProps;

  const handleCreateNewProductSequence = () => {
    const newSeq = [
      ...values.productsSequence,
      {
        index: values.productsSequence.length + 1,
        priceInUsdCents: 0,
        products: [],
        barSize: 1
      }
    ];
    setFieldValue('productsSequence', newSeq);
  };

  const lastIndex = values.productsSequence.length - 1;

  return (
    <div className="w-[528px] mx-auto">
      {values.productsSequence.map(
        (productSequenceItem: ProductsSequence, sequenceIndex: number) => (
          <MilestoneCard
            key={productSequenceItem.index}
            formikProps={formikProps}
            productSequenceItem={productSequenceItem}
            sequenceIndex={sequenceIndex}
            isMilestoneDesign={isMilestoneDesign}
            isFinalReward={sequenceIndex === lastIndex}
          />
        )
      )}
      <Button
        variant="secondary"
        onClick={handleCreateNewProductSequence}
        className="w-full"
        leftIcon={<AddCircleOutlineIcon />}
      >
        {isMilestoneDesign ? 'Add Milestone' : 'Add'}
      </Button>
    </div>
  );
};
export default ConfigurationTab;
